import {ssrSafeLocation} from '@github-ui/ssr-utils'

/**
 * Strips trailing slashes so `/pricing` and `/pricing/` compare equal.
 * Collapses the root path down to a single `/`.
 */
export function normalizePathname(pathname: string): string {
  return pathname.match(/^.*[^/]/)?.[0] ?? '/'
}

/**
 * Determines whether `href` points at the same page as `currentUrl`.
 *
 * Works with both relative (`/pricing`) and absolute
 * (`https://github.com/pricing`) hrefs by resolving them against the current
 * origin, so it behaves identically during SSR (where `ssrSafeLocation` reads
 * the request URL from AsyncLocalStorage) and CSR. Only the hostname and
 * pathname are compared — query string and hash are ignored.
 */
export function matchesCurrentPage(href: string, currentUrl: string): boolean {
  if (!href || !currentUrl) return false

  const base = ssrSafeLocation.origin || undefined

  try {
    const target = new URL(href, base)
    const current = new URL(currentUrl, base)

    return (
      target.hostname === current.hostname && normalizePathname(target.pathname) === normalizePathname(current.pathname)
    )
  } catch {
    return false
  }
}
